/*
  Поиск, который понимает, как на самом деле печатают: латинские домены набирают по-русски
  («кофе» → kofe-zerno.ru), а запрос часто уходит не в той раскладке («rjat» — это «кофе»).
  Запрос превращается в несколько вариантов; совпадение по любому — находка.
*/

const TRANSLIT: Record<string, string> = {
  а: 'a',
  б: 'b',
  в: 'v',
  г: 'g',
  д: 'd',
  е: 'e',
  ё: 'e',
  ж: 'zh',
  з: 'z',
  и: 'i',
  й: 'y',
  к: 'k',
  л: 'l',
  м: 'm',
  н: 'n',
  о: 'o',
  п: 'p',
  р: 'r',
  с: 's',
  т: 't',
  у: 'u',
  ф: 'f',
  х: 'h',
  ц: 'c',
  ч: 'ch',
  ш: 'sh',
  щ: 'sch',
  ъ: '',
  ы: 'y',
  ь: '',
  э: 'e',
  ю: 'yu',
  я: 'ya',
};

const EN = "qwertyuiop[]asdfghjkl;'zxcvbnm,.`";
const RU = 'йцукенгшщзхъфывапролджэячсмитьбюё';

/** Нижний регистр и «ё» как «е»: «темная» находит «Тёмная тема». */
function fold(s: string) {
  return s.toLowerCase().replaceAll('ё', 'е');
}

function translit(s: string) {
  return [...s].map((ch) => TRANSLIT[ch] ?? ch).join('');
}

function swapLayout(s: string) {
  return [...s]
    .map((ch) => {
      const i = EN.indexOf(ch);
      if (i >= 0) return RU[i];
      const j = RU.indexOf(ch);
      return j >= 0 ? EN[j] : ch;
    })
    .join('');
}

/** Варианты запроса: как набрали, транслитом, в другой раскладке и её транслитом. */
export function queryVariants(query: string): string[] {
  const q = fold(query.trim());
  if (!q) return [];
  const swapped = swapLayout(q);
  return [...new Set([q, translit(q), swapped, translit(swapped)])];
}

/** Все слова хотя бы одного варианта запроса встречаются в тексте. */
export function matchesQuery(text: string, query: string): boolean {
  const hay = fold(text);
  const variants = queryVariants(query);
  if (variants.length === 0) return true;
  return variants.some((v) =>
    v
      .split(/\s+/)
      .filter(Boolean)
      .every((w) => hay.includes(w)),
  );
}
